import { useQuery } from 'react-query';

import listedKitService from 'resources/listedkit/listedkit.service';

const getListedKitsByCompanyId = async (companyId) => {
  if (!companyId) {
    return null;
  }

  const listedKits = await listedKitService.findDefaultListedKits(companyId);

  return listedKits;
};

export default function useDefaultListedKits(companyId, queryOptions) {
  return useQuery(
    ['listedKits.getByCompanyId', companyId],
    () => getListedKitsByCompanyId(companyId),
    queryOptions,
  );
}
